import MobileHistoryDrawer from './components/translate/mobileHistoryDrawer'
import MobileUploadDrawer from './components/translate/mobileUploadDrawer'
import TranslateContainer from './components/TranslateContainer'

const TranslatePage = () => {
    return (
        <>
            <TranslateContainer />
            <MobileHistoryDrawer />
            <MobileUploadDrawer />
        </>
    )
}

export default TranslatePage
